import { render, staticRenderFns } from "./SendToManager.vue?vue&type=template&id=b3f419c8"
import script from "./SendToManager.vue?vue&type=script&lang=js"
export * from "./SendToManager.vue?vue&type=script&lang=js"
import style0 from "./SendToManager.vue?vue&type=style&index=0&id=b3f419c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports